import { render, staticRenderFns } from "./CMExamModalBody.vue?vue&type=template&id=16de1b13&lang=pug"
import script from "./CMExamModalBody.vue?vue&type=script&lang=js"
export * from "./CMExamModalBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports